import React from 'react';
import { Link } from 'react-router-dom';

import { colors } from '../../config/colors';
import { DATAOPS_ACTIONS, SCOPE, DATAOPS_ACTIONS_DICTIONARY, FILTER_KEYS } from '../../config/constants';
import { LaunchIcon, EditIcon, ReTrackIcon, BallIcon, CheckIcon, CancelIcon } from './ActionIcons/ActionIcons';
import { isPracticeLaunchedFromDataOps } from '../../helpers/helpers';
import { useDataOpsDispatch } from '../../store/hooks/dataOps';
import { PracticeDataOps } from './types';
import { useRouter } from '../../helpers/customHooks';
import { useFiltersState } from '../../store/hooks';
import { message } from 'antd';
type ActionsProps = {
  practice:PracticeDataOps;
  handleModalOpening:(practice:PracticeDataOps)=>void;
}
const Actions = ({ practice, handleModalOpening }: ActionsProps) => {

  const { execAction, saveSchedule } = useDataOpsDispatch();
  const filterScope = SCOPE.DATAOPS.ENTITIES+":"+practice.game_id;
  const {[FILTER_KEYS.TARGETED_RETRACK]: isTargetedRetrack=false} = useFiltersState(filterScope, FILTER_KEYS.TARGETED_RETRACK);
  const style = { marginTop: '7px', marginRight: '10px', cursor: 'pointer' };
  const progressStatus = DATAOPS_ACTIONS(practice.status_replicaInfo);
  const practiceHasBeenLaunched = isPracticeLaunchedFromDataOps(progressStatus);
  return (
    <>
      <LaunchIcon
        onClick={() => execAction(practice, DATAOPS_ACTIONS_DICTIONARY.launchInstance)}
        width="15px"
        height="15px"
        fill={progressStatus[0]}
        style={style}
      />
      <Link to={SCOPE.DATAOPS.ROUTES.ENTITIES(practice.game_id)} style={!practiceHasBeenLaunched ? {pointerEvents: 'none'} : undefined}>
        <EditIcon
          width="15px"
          height="15px"
          fill={colors.gray}
          style={style}
          onClick={() => handleModalOpening(practice)} />
      </Link>
      <ReTrackIcon
        onClick={isTargetedRetrack?
          () => execAction(practice, DATAOPS_ACTIONS_DICTIONARY.tretrackInstance):
          ()=> message.error({ content: 'Select Entities for targeted retrack', className: 'antd-message-alert'},15)}
        width="15px"
        height="15px"
        title={isTargetedRetrack? 'Run Targeted Retrack':'No entities selected for targeted retrack'}
        fill={progressStatus[1]}
        style={style}
      />
      <ReTrackIcon
        onClick={() => execAction(practice, DATAOPS_ACTIONS_DICTIONARY.retrackInstance)}
        width="15px"
        height="15px"
        fill={progressStatus[1]}
        style={style}
      />
      <BallIcon
        onClick={() => execAction(practice, DATAOPS_ACTIONS_DICTIONARY.ballFlightRetrack)}
        width="15px"
        height="15px"
        fill={progressStatus[2]}
        style={style}
      />
      <CheckIcon onClick={() => saveSchedule(practice)} width="15px" height="15px" fill={colors.gray} style={style} />
      <CancelIcon
        onClick={() => execAction(practice, DATAOPS_ACTIONS_DICTIONARY.finalizeRetrack)}
        width="15px"
        height="15px"
        fill={progressStatus[3]}
        style={style}
      />
    </>
  );
};

export default Actions;
